import { useLocation } from 'react-router-dom';
import useInLightMode from '../../../hooks/useInLightMode';
import { useUserDateTime } from '../../timezone/hooks/useUserDateTime';

export const useGetChartOptions = (
  yAxisLabel: string,
  title: string,
  yAxisMin?: number,
  yAxisMax?: number,
  xAxisUnit?: string
) => {
  const {
    monthAbbreviatedWordDayFormat,
    timeFormatNoSeconds,
    timeFormatHoursOnlyWithAMPM,
    dateFormat,
    timeFormat,
  } = useUserDateTime();
  const inLightMode = useInLightMode();
  const pathname = useLocation().pathname;
  const inEditMode = pathname.includes('edit');
  return {
    spanGaps: false,
    animation: {
      duration: 0,
    },
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: title,
        color: inLightMode ? undefined : '#ffffff',
      },
      tooltip: {
        enabled: !inEditMode,
        interaction: {
          intersect: false,
        },
        callbacks: {
          label: (context: any) => {
            const dataPoint = context.parsed.y;
            if (context.raw.wind_dir)
              return `${dataPoint.toFixed(2)} ${yAxisLabel} (${
                context.raw.wind_dir
              })`;
            return dataPoint.toFixed(2) + ' ' + yAxisLabel;
          },
        },
      },
    },
    select: {
      line: false,
    },
    elements: {
      point: {
        radius: 0,
      },
    },
    scales: {
      y: {
        min: yAxisMin,
        max: yAxisMax,
        ticks: {
          color: inLightMode ? undefined : '#ffffff',
        },
        grid: {
          color: inLightMode ? undefined : 'rgba(255,255,255,0.5)',
          tickLength: 5,
        },
        title: {
          display: true,
          color: inLightMode ? undefined : 'white',
          text: yAxisLabel,
        },
      },
      x: {
        type: 'time',
        time: {
          tooltipFormat: `${dateFormat} ${timeFormat}`,
          unit: xAxisUnit,
          displayFormats: {
            day: monthAbbreviatedWordDayFormat,
            hour: timeFormatHoursOnlyWithAMPM,
            minute: timeFormatNoSeconds,
          },
        },
        ticks: {
          color: inLightMode ? undefined : '#ffffff',
        },
        grid: {
          color: inLightMode ? undefined : 'rgba(255,255,255,0.5)',
          tickLength: 5,
        },
        title: {
          display: true,
          color: inLightMode ? undefined : 'white',
          text: 'Time',
        },
      },
    },
  };
};
